<template>
  <div>
    <div class="content">
      <van-form @submit="submitForm">
        <van-cell-group inset>
          <uploadPanel pannelTitle="上传磅单" uploadType="Pound"  uploadTypeInfo="uploadPound" modelTitle="pound_image" :isRequired="true"  max-count="1" @afterRead="afterImageRead" @beforeDelete="beforeImageDelete"></uploadPanel>

        </van-cell-group>
        <div class="margin-box"></div>
        <van-cell-group inset>
          <van-field label="上一载品种" value="上一载品种" readonly />
          <van-field label="上一载时间" value="上一载时间" readonly />
        </van-cell-group>

        <div class="add-btn-box">
          <div class="btn-box">
            <van-button round block type="primary" class="addBtn2">提交</van-button>
          </div>
        </div>

      </van-form>
    </div>
    <Tabbar></Tabbar>
  </div>
</template>
<script>
import Tabbar from "@/views/Public/tabbarTpl.vue"
import uploadPanel from "@/components/uploadSteamImage/uploadPanel.vue";
export default {
  components: {
    Tabbar,
    uploadPanel,
  },
  data(){
    return {
      pound_image:[],//上传磅单
      pound_url:'',

    };
  },
  methods:{
    afterImageRead(resData) {
      var uploadTypeInfo = resData.uploadTypeInfo;
      switch (uploadTypeInfo) {
        case "uploadXszFront":
          this.uploadXszFront(resData);
        break;
        case "uploadXszFyFront":
          this.uploadXszFyFront(resData);
        break;
      }

    },
    beforeImageDelete(uploadTypeInfo)
    {
      switch (uploadTypeInfo) {
        case "uploadXszFront":
          this.xsz_image = [];
          this.xsz_url = "";
        break;
        case "uploadXszFyFront":
          this.xsz_fy_image = [];
          this.xsz_fy_url = "";
        break;
      }
    },
    submitForm(){
      console.log('表单提交');
    },

  },
}
</script>
<style lang="scss" scoped>
.content {
    margin: 1rem 0 3.75rem;
    padding-bottom: env(safe-area-inset-bottom);
    .margin-box{
      height: 1rem;
      width: 100%;
    }


    .add-btn-box {
        width: 100%;
        margin-top: 1rem;
        padding-bottom: env(safe-area-inset-bottom);
        .btn-box {
            .addBtn2 {
                width: 90%;
                margin: 0 auto;
            }
        }
    }
}
</style>
